var React = require('react');

function SCrossLarge22N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m18.69673,17.28266l-6.28267-6.28266,6.28267-6.28266c.39115-.38982.39223-1.02292.00241-1.41407-.38982-.39115-1.02292-.39223-1.41407-.00241l-.00241.00241-6.28266,6.28267L4.71734,3.30327c-.38981-.39116-1.02291-.39226-1.41407-.00245s-.39226,1.02291-.00245,1.41407l.00245.00245,6.28267,6.28266-6.28267,6.28266c-.39115.38982-.39223,1.02292-.00241,1.41407s1.02292.39223,1.41407.00241l.00241-.00241,6.28266-6.28267,6.28266,6.28267c.38983.39114,1.02293.3922,1.41407.00237s.3922-1.02293.00237-1.41407l-.00237-.00237Z","fill":"var(--iconFill, #464646)"}));
}

SCrossLarge22N.defaultProps = {"id":"ImportedIcons","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SCrossLarge22N;

SCrossLarge22N.default = SCrossLarge22N;
